export interface Chore {
  id: string;
  emoji: string;
  name: string;
  coins: number;
}

export const CHORE_EMOJIS = ["🧹","🍽️","🗑️","🌱","🧺","🪟","🐶","🛁","🚗","📦","🧽","🛒","🌻","🏠","🐱"];

export const EMPTY_CHORES = {
  chores:  [] as Chore[],
  pending: [] as string[],
  history: [] as { id: string; choreId: string; choreName: string; choreEmoji: string; coins: number; date: string }[],
};
